// extracted by mini-css-extract-plugin
module.exports = {"content":"Disclaimer_content__4oj0D"};